// apps/admin/src/hooks/useAdvertisementsBySupplierId.ts

import {
  ApiResponse,
  AdvertisementWithMedia,
  PaginationResponse,
} from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export function useAdvertisementsBySupplierId(
  supplierId: number | undefined,
  query: string | undefined,
) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<
    ApiResponse<PaginationResponse<AdvertisementWithMedia>>
  >(
    token && supplierId
      ? `/api/ad-supplier/${supplierId}/advertisements${query ?? '?supplierId=' + supplierId}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    advertisements: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading,
    isError: error,
    mutate,
  }
}
